import { IconStarEmpty, IconStarFilled, IconStarHalf } from 'assets'
import React from 'react'
import { Text2 } from '../Text2'
import styles from './RatingStars.module.scss'
import { RatingStarsProps } from './RatingStars.types'

const RatingStarsComponent = (props: RatingStarsProps) => {
  const { rating, reviewsCnt } = props

  const renderStar = (_, index: number) => {
    let Icon
    const starIndex = index + 1

    switch (true) {
      case rating >= starIndex: {
        Icon = IconStarFilled
        break
      }
      case rating < starIndex && rating > index: {
        Icon = IconStarHalf
        break
      }
      default: {
        Icon = IconStarEmpty
        break
      }
    }

    return <Icon key={index} viewBox='0 0 20 20' width={16.4} height={16.4} />
  }

  return (
    <div className={styles.container} title={`rating: ${rating || 0}`}>
      {Array(5)
        .fill('')
        .map(renderStar)}
      {!!reviewsCnt && (
        <Text2 className={styles.text}>
          {rating} ({reviewsCnt} review{reviewsCnt > 1 ? 's' : ''})
        </Text2>
      )}
    </div>
  )
}

const RatingStars = RatingStarsComponent
export { RatingStars }
